import { useTranslation } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import SignDraw from "@CubeComponents/html/signDraw";
import { useRef, useState } from "react";

function DrawSignature({ previewMode = false, defaultImage, drawSignatureCallback }: any) {
  const { t } = useTranslation();
  const signRef = useRef<any>(null);
  const [createdSignature, setCreatedSignature] = useState(defaultImage);

  const clearSignatureHandler = () => {
    signRef.current.clear();
    handleCreated(null);
  };

  const handleCreated = (data: any) => {
    setCreatedSignature(data);
    if (drawSignatureCallback) {
      drawSignatureCallback({ base64ImageStr: data });
    }
  };

  return (
    <div className="w-full">
      {!previewMode ? (
        <>
          <SignDraw ref={signRef} setCreatedSignature={handleCreated} initialImageUrl={defaultImage} />
          <div className="flex items-center justify-between pt-2">
            <ButtonComponent
              buttonType={BUTTON_TYPES.TEXT_BUTTON}
              onClick={clearSignatureHandler}
              disabled={!createdSignature}
            >
              {t("Clear")}
            </ButtonComponent>
          </div>
        </>
      ) : (
        <div>
          <div className="border border-[#c6d0df]">
            <img src={createdSignature} />
          </div>
        </div>
      )}
    </div>
  );
}

export default DrawSignature;
